/**
 * ПОСТОЯННЫЕ МЕТКИ ПАЙПЛАЙНА ЗАГРУЗКИ СЦЕНЫ (render-profile, 09.10).
 *
 * Разбор «первая загрузка ~10 с» начинается с честных фаз. Модуль ставит
 * PerformanceMark/Measure на местах:
 *
 *   scene:bundle-fetch   — сеть + JSON.parse + валидация бандла (api.bundle)
 *   scene:build-meshes   — построение 3D-объектов сущностей (buildFromCanonical)
 *   scene:apply          — подключение к сцене: floor/contact shadows/room shell/
 *                          BVH/подгон камеры (applyScene)
 *   scene:load-total     — от прихода бандла до готового loader.status='ready'
 *
 * Читаются в DevTools → Performance / `performance.getEntriesByType('measure')`
 * и внешними профилировщиками без пересборки. Все вызовы безопасны в средах
 * без performance.mark (jsdom, старые Safari).
 */

type MarkName =
  | 'scene:bundle-fetch-start'
  | 'scene:bundle-fetch-end'
  | 'scene:build-start'
  | 'scene:build-meshes-start'
  | 'scene:build-meshes-end'
  | 'scene:apply-start'
  | 'scene:apply-end'
  | 'scene:ready';

export function sceneMark(name: MarkName): void {
  try {
    performance.mark(name);
  } catch { /* среда без User Timing */ }
}

export function sceneMeasure(name: string, start: MarkName, end: MarkName): void {
  try {
    performance.measure(name, start, end);
  } catch { /* метки нет — середина пайплайна не исполнялась */ }
}

export type SceneLoadTimings = {
  bundleFetchMs: number | null;
  buildMeshesMs: number | null;
  applyMs: number | null;
  totalMs: number | null;
};

/** Снимок последних измерений пайплайна — для HUD-диагностики и тестов. */
export function readSceneLoadTimings(): SceneLoadTimings {
  const last = (name: string): number | null => {
    try {
      const list = performance.getEntriesByName(name, 'measure');
      const entry = list[list.length - 1] as PerformanceMeasure | undefined;
      return entry ? Math.round(entry.duration * 100) / 100 : null;
    } catch { return null; }
  };
  return {
    bundleFetchMs: last('scene:bundle-fetch'),
    buildMeshesMs: last('scene:build-meshes'),
    applyMs: last('scene:apply'),
    totalMs: last('scene:load-total'),
  };
}
